import { useDispatch, useSelector } from "react-redux";
import { AppStore } from "../../../redux/store";
import { toogleAction } from "../../../redux/features/navigation";
import { isLoggedIn } from "../../../helpers/authHelper";
import { getAppPropiSpaPath } from "../../../helpers/realmHelpers";

export function useNavAuth(country?: string) {
  const user = useSelector((store: AppStore) => store.auth);
  const { visible: showNav } = useSelector((store: AppStore) => store.navigation);
  const dispatch = useDispatch();
  const isLogged = isLoggedIn(user);

  const doShowNav = () => {
    if (isLogged) {
      dispatch(toogleAction(!showNav));
    } else {
      window.open(`${getAppPropiSpaPath()}/${country}/auth/login`, "_self");
    }
  };

  return { isLogged, showNav, doShowNav, user };
}
